import {isApiError as isApiErrorTypeGuard} from "services/http/ApiError";

/**
 * Type guard to check whether a given error matches the shape of a serialized error
 * (e.g., from Redux or API responses) containing optional `message` or `code` fields.
 */
export const isSerializedError = (
  error: unknown,
): error is {message?: string; code?: string} => {
  return typeof error === "object" && error != null && "message" in error;
};

/**
 * Type guard to check if an unknown error is a native JavaScript `Error` object.
 */
export const isNativeError = (error: unknown): error is Error => {
  return error instanceof Error;
};

/**
 * Re-export the ApiError type guard from your ApiError module.
 */
export const isApiError = isApiErrorTypeGuard;
